import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import FiscalSalesVisualizerComponent from './fiscal-sales-visualizer.component';

let FiscalSalesVisualizerModule = angular
  .module('FiscalSalesVisualizer', [
    uiRouter
  ])
  .component('fiscalSalesVisualizer', FiscalSalesVisualizerComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('fiscalSalesVisualizer', {
      url: '/fiscal-sales-visualizer',
      data: {
        authRequired: true,
        permsRequired: ['sales-visualizer']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'fiscalSalesVisualizer'
        }
      }
    });
  })
  .name;

export default FiscalSalesVisualizerModule;



// WEBPACK FOOTER //
// ./src/app/pages/fiscal-sales-visualizer/fiscal-sales-visualizer.module.js